import { render, staticRenderFns } from "./LayoutSelect.vue?vue&type=template&id=53390480"
import script from "./LayoutSelect.vue?vue&type=script&lang=ts"
export * from "./LayoutSelect.vue?vue&type=script&lang=ts"
import style0 from "./LayoutSelect.vue?vue&type=style&index=0&id=53390480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports